import _styled from "styled-components";
var _excluded = ["className", "style", "content", "container", "onClickX"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType, useForwardedRef } from '@adsk/alloy-helpers';
import Icon from '@adsk/alloy-icon';
import theme from '@adsk/alloy-theme';
import { OverflowTooltip } from '@adsk/alloy-tooltip';
var Token = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      style = _ref.style,
      content = _ref.content,
      container = _ref.container,
      onClickX = _ref.onClickX,
      props = _objectWithoutProperties(_ref, _excluded);

  var tokenRef = useForwardedRef(ref);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    ref: tokenRef,
    className: className,
    "data-testid": 'token'
  }, props, {
    $_css: [{
      display: 'flex',
      height: 24,
      alignItems: 'center',
      padding: '2px 8px',
      margin: '4px',
      borderRadius: '4px',
      background: theme.colors.charcoal100,
      color: theme.colors.charcoal900,
      userSelect: 'none'
    }, theme.typography.bodyMedium, style]
  }), /*#__PURE__*/React.createElement(OverflowTooltip, {
    singleLine: true,
    autoTipOnEllipsis: true,
    target: tokenRef,
    container: container,
    getTargetProps: function getTargetProps() {
      return {
        style: {
          maxWidth: 172
        }
      };
    }
  }, content), /*#__PURE__*/React.createElement(Icon, {
    type: Icon.TYPES.X,
    size: 16,
    color: theme.colors.charcoal700,
    style: {
      marginLeft: 8,
      pointerEvents: 'auto',
      cursor: 'pointer'
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      onClickX === null || onClickX === void 0 ? void 0 : onClickX();
    }
  }));
});
Token.displayName = 'Token';
Token.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,

  /** Class applied to the root element */
  className: PropTypes.string,

  /** Token content */
  content: PropTypes.node,

  /** The container */
  container: PropTypes.any,

  /** Function executed upon clicking the X icon */
  onClickX: PropTypes.func
};
export default Token;

var _StyledDiv = _styled("div").withConfig({
  displayName: "Token___StyledDiv",
  componentId: "sc-gu5iak-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=Token.js.map